import { styled } from 'styled-components';

import FormRow from 'components/FormRow';
import Input from 'components/ui/Input';
import Radio from 'components/ui/Radio';
import { ImageFormRowProps } from 'types';

const RadioView = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 20px;
  row-gap: 10px;
  min-height: 33px;
`;

const CSVView = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  height: 33px;
`;

const TargetTypeRow = ({ nodeDataSave, useFormReturn }: ImageFormRowProps) => {
  const {
    formState: { errors },
    register,
    watch,
  } = useFormReturn;

  const target = watch('target');

  return (
    <FormRow label="정답 형식" direction="row" labelWidth={100} pos="left">
      <RadioView>
        <Radio
          id="target_folder"
          {...register('target', {
            onChange: nodeDataSave,
          })}
          label="폴더명"
          value={'folder'}
        />
        <Radio
          id="target_input"
          {...register('target', {
            onChange: nodeDataSave,
          })}
          label="입력 데이터"
          value={'input'}
        />
        <CSVView>
          <Radio
            id="target_csv"
            {...register('target', {
              onChange: nodeDataSave,
            })}
            label="별도 CSV"
            value={'csv'}
          />
          {target === 'csv' && (
            <Input
              style={{ maxWidth: '130px' }}
              {...register('csvName', { required: 'CSV 파일 이름을 입력해주세요', onBlur: nodeDataSave })}
              error={errors?.csvName?.message}
              placeholder="CSV 파일 이름"
            />
          )}
        </CSVView>
      </RadioView>
    </FormRow>
  );
};

export default TargetTypeRow;
